import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input, SelectAutocompleteMultiple } from 'components';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { formatStandardPlace, STANDARD_PLACES_OF_SERVICE } from '../constants';

const isSamePlace = (a, b) => a?.code === b?.code && (a?.modifier || '') === (b?.modifier || '');

export const CreateEditPlace = ({ info, afterSuccess }) => {
    const dispatch = useDispatch();
    const ACTION_TYPE = info ? 'EDIT_PLACE_BY_ID_GLOBAL' : 'CREATE_PLACE_GLOBAL';
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const { close } = useModal();
    const orgPlaces = useSelector((state) => state.system.places);

    const {
        control,
        handleSubmit,
        reset,
        setValue,
    } = useForm({
        defaultValues: {
            standardPlace: null,
            name: '',
            code: '',
            modifier: ''
        }
    });

    useEffect(() => {
        if (info) {
            reset({
                name: info.name || '',
                code: info.code || '',
                modifier: info.modifier || ''
            });
        }
    }, [info, reset]);

    useEffect(() => {
        if (!!success) {
            if (afterSuccess) afterSuccess();
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            reset();
        }
    }, [success]);

    function handleSelectStandard(place) {
        if (!place) return;
        const options = { shouldValidate: true, shouldDirty: true };
        setValue('name', place.name, options);
        setValue('code', place.code, options);
        setValue('modifier', place.modifier || '', options);
    }

    function handleSave(data) {
        const payload = {
            name: data.name,
            code: data.code,
        };
        if (data.modifier) {
            payload.modifier = data.modifier;
        }

        if (info) {
            dispatch(systemActions.editPlaceByIdGlobal(payload, info.id));
        } else {
            dispatch(systemActions.createPlaceGlobal(payload));
        }
    }

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Place of Service' : 'Add Place of Service'}</p>
            <form onSubmit={handleSubmit(handleSave)}>
                <div className="modal-body-wrapper">
                    <SelectAutocompleteMultiple
                        name="standardPlace"
                        label="Standard Place of Service"
                        placeholder="Search by code or name"
                        control={control}
                        options={STANDARD_PLACES_OF_SERVICE}
                        renderValue={formatStandardPlace}
                        handleChange={handleSelectStandard}
                        renderCustomRow={(place) => (
                            <div>
                                <p>{formatStandardPlace(place)}</p>
                                {orgPlaces?.some((item) => isSamePlace(item, place)) && (
                                    <p style={{ color: 'gray', fontSize: '12px' }}>Already added</p>
                                )}
                            </div>
                        )}
                    />
                    <Input
                        name="name"
                        label="Name*"
                        variant="outlined"
                        control={control}
                        maxLength={50}
                        rules={{
                            required: 'Name is required.',
                            maxLength: {
                                value: 50,
                                message: 'Max length is 50 characters.',
                            },
                        }}
                    />
                    <Input
                        name="code"
                        label="Code*"
                        variant="outlined"
                        control={control}
                        maxLength={2}
                        rules={{
                            required: 'Code is required.',
                            pattern: {
                                value: /^\d{2}$/,
                                message: 'Code must be 2 digits (e.g. 11, 02).',
                            },
                        }}
                    />
                    <Input
                        name="modifier"
                        label="Modifier"
                        variant="outlined"
                        control={control}
                        maxLength={5}
                        rules={{
                            maxLength: {
                                value: 5,
                                message: 'Max length is 5 characters.',
                            },
                        }}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
